module.exports = __webpack_public_path__ + "static/media/mc_settings_icon.5dc7f261.svg";